import newsletterModal from './newsletter-modal';

class Blog {
  constructor(element) {
    this.element = element;
    this.categories = this.element.querySelectorAll('[data-element="blog-category"]');
    this.subjects = this.element.querySelectorAll('[data-element="blog-subject"]');
    this.classifications = this.element.querySelectorAll('[data-element="blog-classification"]');
    this.list = this.element.querySelector('[data-element="blog-list"]');
    this.loadMore = this.element.querySelector('[data-element="blog-load-more"]');
    this.loadMoreBtn = this.element.querySelector('[data-element="blog-load-more-btn"]');
    this.loadMoreLoader = this.element.querySelector('[data-element="blog-load-more-loader"]');
    this.rest = wpRestApi; // eslint-disable-line
    this.page = 2;
    this.category = 0;
    this.subject = 0;
    this.tag = 0;
    this.segment = '';
    this.type = '';
    this.classification = 0;
  }

  init() {
    this.checkTerms();
    this.loadMoreBtn.addEventListener('click', this.onLoadMoreBtnClick.bind(this));
    this.categories.forEach((category) => {
      category.addEventListener('click', this.onCategoryClick.bind(this, category));
    });
    this.subjects.forEach((subject) => {
      subject.addEventListener('click', this.onSubjectClick.bind(this, subject));
    });
    this.classifications.forEach((classification) => {
      classification.addEventListener('click', this.onClassificationClick.bind(this, classification));
    });
  }

  checkTerms() {
    if (this.element.hasAttribute('data-category')) {
      this.category = this.element.dataset.category;
    }
    if (this.element.hasAttribute('data-tag')) {
      this.tag = this.element.dataset.tag;
    }
    if (this.element.hasAttribute('data-segment')) {
      this.segment = this.element.dataset.segment;
    }
    if (this.element.hasAttribute('data-type')) {
      this.type = this.element.dataset.type;
    }
  }

  onLoadMoreBtnClick() {
    this.loadPosts();
  }

  onCategoryClick(category) {
    if (category.classList.contains('is-active')) {
      return;
    }

    this.removeAllCategoriesActive();
    category.classList.add('is-active');
    this.clearPosts();
    this.showLoadMore();
    this.page = 1;
    this.category = category.dataset.id;
    this.loadNewsletter = true;
    this.loadPosts();
  }

  onSubjectClick(subject) {
    if (subject.classList.contains('is-active')) {
      return;
    }

    this.removeAllSubjectsActive();
    subject.classList.add('is-active');
    this.clearPosts();
    this.showLoadMore();
    this.page = 1;
    this.subject = subject.dataset.id;
    this.loadNewsletter = true;
    this.loadPosts();
  }

  onClassificationClick(classification) {
    if (classification.classList.contains('is-active')) {
      return;
    }

    this.removeAllClassificationsActive();
    classification.classList.add('is-active');
    this.clearPosts();
    this.showLoadMore();
    this.page = 1;
    this.classification = classification.dataset.id;
    this.loadNewsletter = true;
    this.loadPosts();
  }

  loadPosts() {
    this.showLoader();

    const url = new URL(this.rest.url + 'blog/load-more');
    url.searchParams.append('category', this.category);
    url.searchParams.append('subject', this.subject);
    url.searchParams.append('page', this.page);
    url.searchParams.append('tag', this.tag);
    url.searchParams.append('segment', this.segment);
    url.searchParams.append('type', this.type);
    url.searchParams.append('classification', this.classification);

    fetch(url.href, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      return response.json();
    }).then((data) => {
      if (null !== data.html) {
        this.list.insertAdjacentHTML('beforeend', data.html);
      }

      if (true === data.hideBtn) {
        this.hideLoadMore();
      }

      this.page++;
      this.hideLoader();
      newsletterModal.init();
    }).catch((error) => {
      console.error(error);
      this.hideLoader();
    });
  }

  clearPosts() {
    this.list.replaceChildren();
  }

  removeAllCategoriesActive() {
    this.categories.forEach((category) => {
      category.classList.remove('is-active');
    });
  }

  removeAllSubjectsActive() {
    this.subjects.forEach((subject) => {
      subject.classList.remove('is-active');
    });
  }

  removeAllClassificationsActive() {
    this.classifications.forEach((classification) => {
      classification.classList.remove('is-active');
    });
  }

  hideLoadMore() {
    this.loadMore.classList.add('blog-list__load-more--hidden');
  }

  showLoadMore() {
    this.loadMore.classList.remove('blog-list__load-more--hidden');
  }

  hideLoader() {
    this.loadMoreLoader.classList.remove('blog-list__loader--show');
  }

  showLoader() {
    this.loadMoreLoader.classList.add('blog-list__loader--show');
  }
}

const blog = {
  init() {
    const blogElement = document.querySelector('[data-module="blog"]');

    if (blogElement) {
      const blogItem = new Blog(blogElement);
      blogItem.init();
    }
  },
};

export default blog;
